import ValidationInterface from "@/plans/common/validation-interface";
import {
  eduPlusCategories,
  basePlanCategories, SDKCategories, SDKUCCategories,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [this.current(eduPlusCategories).require(["ZVP", "ZVC"], { billingCycleEqual: true, licenseMatch: false })];
  }

  async conflicts() {
    return this.current(eduPlusCategories).conflict(
      [...basePlanCategories.filter((c) => !eduPlusCategories.includes(c)), ...SDKCategories, ...SDKUCCategories],
    );
  }
}
